import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Label,
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  getProducts,
  deleteProduct,
  resetProducts,
} from "../../../../store/product/actions";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  DataTable,
  TableRowField,
  ExportCSV,
  MainLoader,
} from "../../../../components";
import { selectUserRole } from "../../../../store/user/selector";
import { selectCategoriesForSelect } from "../../../../store/category/selector";
import {
  getCategories,
  resetCategories,
} from "../../../../store/category/actions";
import { roles, layout } from "../../../../common/constants";
import { formatHelper } from "../../../../common/helpers";
import MediaQuery from "react-responsive";
import { getAll as allProductsExport } from "../../../../service/product";
import { exportExcel } from "./excel";
class ProductList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      filter: "",
      selectedCategory: null,
      loadingExport: false,
    };
    this.handleObtainProductsExport =
      this.handleObtainProductsExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handleInputFilterChange = this.handleInputFilterChange.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
  }

  async componentDidMount() {
    await this.props.getCategories({ reset: true });
    this.performGetProducts(true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categories.length == 0 && this.props.categories.length > 0) {
      this.setState({ selectedCategory: this.props.categories[0] });
    }

    this.checkProductDelete(prevProps);
  }

  componentWillUnmount() {
    this.props.resetProducts();
  }

  performGetProducts(reset = false) {
    const { categories, getProducts } = this.props;
    const { page, filter, selectedCategory } = this.state;

    if (categories.length == 0) return;

    var categoryId = 0;
    if (selectedCategory) categoryId = selectedCategory.value;

    getProducts({ page, filter, categoryId, reset });
  }

  async checkProductDelete(prevProps) {
    if (prevProps.deletedProduct == null && this.props.deletedProduct != null) {
      toast.success("Producto eliminado satisfactoriamente");
      await this.setState({ page: 1 });
      this.performGetProducts();
    } else if (
      prevProps.deleteError == null &&
      this.props.deleteError != null
    ) {
      toast.error(this.props.deleteError);
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetProducts();
  }

  performDeleteProduct(id) {
    Swal({
      title: "Eliminar producto",
      text: "¿Estás seguro que deseas eliminar el producto?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        this.props.deleteProduct(id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  async filterProducts() {
    await this.setState({ page: 1 });
    this.performGetProducts();
  }

  async handleInputFilterChange(e) {
    if (e.key === "Enter") {
      this.filterProducts();
    }
  }

  async handleCategoryChange(value) {
    if (value == this.state.selectedCategory) return;
    await this.setState({ selectedCategory: value, page: 1 });
    this.filterProducts();
  }

  optionsFormatterColumn(cell, row) {
    if (this.props.role == roles.SUPER_ADMIN) {
      return (
        <UncontrolledButtonDropdown>
          <DropdownToggle size="sm" color="primary">
            <i className="fa fa-bars"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/products/${row.id}/detail`
                )
              }
            >
              <i className="fa fa-eye mr-1"></i> Detalle
            </DropdownItem>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/products/${row.id}/edit`
                )
              }
            >
              <i className="fa fa-edit mr-1"></i> Editar
            </DropdownItem>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/products/${row.id}/orders`
                )
              }
            >
              <i className="fa fa-list"></i> Pedidos
            </DropdownItem>
            <DropdownItem
              disabled={this.props.deleteLoading}
              onClick={() => this.performDeleteProduct(row.id)}
            >
              <i className="fa fa-trash mr-1"></i> Eliminar
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      );
    } else if (this.props.role == roles.ADMIN) {
      return (
        <UncontrolledButtonDropdown>
          <DropdownToggle size="sm" color="primary">
            <i className="fa fa-bars"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/products/${row.id}/detail`
                )
              }
            >
              <i className="fa fa-eye mr-1"></i> Detalle
            </DropdownItem>
            <DropdownItem
              onClick={() =>
                this.props.history.push(
                  `/administration/products/${row.id}/orders`
                )
              }
            >
              <i className="fa fa-list"></i> Pedidos
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      );
    } else {
      return (
        <Button
          type="button"
          color="primary"
          size="sm"
          onClick={() =>
            this.props.history.push(`/administration/products/${row.id}/detail`)
          }
        >
          <i className="fa fa-eye"></i>
        </Button>
      );
    }
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.products}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainProductsExport() {
    this.setState({ loadingExport: true });
    allProductsExport(0, null, 0)
      .then((response) => {
        exportExcel(response.data.data);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "xs",
        text: "Producto",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="Código:" value={row.code} />
              <TableRowField
                label="Categoría:"
                value={row.category ? row.category.name : "Sin categoría"}
              />
              <TableRowField
                label="Precio (S/):"
                value={formatHelper.toMoney(row.price)}
              />
              <TableRowField
                label="Costo (S/):"
                value={formatHelper.toMoney(row.cost)}
              />
              <TableRowField
                label="Descuento (%):"
                value={formatHelper.toBlankDiscount(row.discount)}
              />
            </div>
          );
        },
      },
      columnOption,
    ];

    const columnsSM = [
      {
        dataField: "xs",
        text: "Producto",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="Nombre:" value={row.name} />
              <TableRowField label="Código:" value={row.code} />
              <TableRowField
                label="Categoría:"
                value={row.category ? row.category.name : "Sin categoría"}
              />
            </div>
          );
        },
      },
      {
        dataField: "price",
        text: "Precio (S/)",
        formatter: (cell) => {
          return <span>{formatHelper.toMoney(cell)}</span>;
        },
      },
      {
        dataField: "cost",
        text: "Costo (S/)",
        formatter: (cell) => {
          return <span>{formatHelper.toMoney(cell)}</span>;
        },
      },
      {
        dataField: "discount",
        text: "Descuento (%)",
        formatter: (cell) => {
          return <span>{formatHelper.toBlankDiscount(cell)}</span>;
        },
      },
      columnOption,
    ];

    const columns = [
      {
        dataField: "name",
        text: "Nombre",
      },
      {
        dataField: "code",
        text: "Código",
      },

      {
        dataField: "category.name",
        text: "Categoría",
      },
      {
        dataField: "price",
        text: "Precio (S/)",
        formatter: (cell) => {
          return <span>{formatHelper.toMoney(cell)}</span>;
        },
      },
      {
        dataField: "cost",
        text: "Costo (S/)",
        formatter: (cell) => {
          return <span>{formatHelper.toMoney(cell)}</span>;
        },
      },
      {
        dataField: "discount",
        text: "Descuento (%)",
        formatter: (cell) => {
          return <span>{formatHelper.toBlankDiscount(cell)}</span>;
        },
      },
      {
        dataField: "discount_corporative",
        text: "Descuento Corporativo (%)",
        formatter: (cell) => {
          return <span>{formatHelper.toBlankDiscount(cell)}</span>;
        },
      },
      columnOption,
    ];
    if (this.props.loading || this.props.loadingCategories) {
      return <MainLoader />;
    }

    return (
      <div className="animated">
        <Card>
          <CardHeader>
            <i className="icon-layers"></i>Productos
          </CardHeader>
          <CardBody>
            <MediaQuery minDeviceWidth={600}>
              {(matches) => {
                if (matches) {
                  return (
                    <Row className="mb-2">
                      <Col sm="4">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterProducts()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="5">
                        <Row>
                          <Col md="3">
                            <Label className="mt-2">Categoría:</Label>
                          </Col>
                          <Col md="9">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingCategories}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.categories}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleCategoryChange}
                              value={this.state.selectedCategory}
                              isDisabled={this.props.loadingCategories}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm="3">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainProductsExport}
                        />
                      </Col>
                    </Row>
                  );
                } else {
                  return (
                    <Row className="mb-2">
                      <Col sm="4">
                        <InputGroup>
                          <Input
                            type="text"
                            id="input1-group2"
                            name="input1-group2"
                            placeholder="Buscar"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.setState({ filter: e.target.value })
                            }
                            onKeyPress={this.handleInputFilterChange}
                          />
                          <div className="input-group-prepend">
                            <Button
                              type="button"
                              color="primary"
                              onClick={() => this.filterProducts()}
                            >
                              <i className="fa fa-search"></i>
                            </Button>
                          </div>
                        </InputGroup>
                      </Col>
                      <Col sm="5">
                        <Row>
                          <Col md="2">
                            <Label className="mt-2">Categoría:</Label>
                          </Col>
                          <Col md="10">
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isLoading={this.props.loadingCategories}
                              isSearchable={true}
                              noOptionsMessage={() => {
                                return messages.SELECT_NO_OPTIONS;
                              }}
                              placeholder=""
                              options={this.props.categories}
                              loadingMessage={() => {
                                return messages.SELECT_LOADING;
                              }}
                              onChange={this.handleCategoryChange}
                              value={this.state.selectedCategory}
                              isDisabled={this.props.loadingCategories}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm="2">
                        <ExportCSV
                          disabled={this.state.loadingExport}
                          exportCSV={this.handleObtainProductsExport}
                        />
                      </Col>
                    </Row>
                  );
                }
              }}
            </MediaQuery>
            <hr className="my-4" />
            {this.props.role == roles.SUPER_ADMIN && (
              <Row className="mb-2">
                <Col>
                  <div className="float-right">
                    <Button
                      color="primary"
                      onClick={() =>
                        this.props.history.push("/administration/products/add")
                      }
                    >
                      <i className="fa fa-plus mr-1"></i> Nuevo
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(columnsSM)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(columns)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { products, error, loading, pageSize, total } =
    state.product.productList;

  return {
    products,
    error,
    loading,
    pageSize,
    total,
    categories: selectCategoriesForSelect(state),
    loadingCategories: state.category.categoryList.loading,
    deletedProduct: state.product.deleteProduct.product,
    deleteError: state.product.deleteProduct.error,
    deleteLoading: state.product.deleteProduct.loading,
    role: selectUserRole(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProducts,
      deleteProduct,
      resetProducts,
      getCategories,
      resetCategories,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductList/ProductList.js